import React from 'react';
import swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { obtenirDocument, telechargerFichier } from '../App_Code/API';

const swalReact = withReactContent(swal);

const LigneTelechargement = ({
    Nom, Token, URL, Num,
}) => (
    <a
        className="btn btn-outline-primary btn-block text-truncate"
        target="_blank"
        href={URL || telechargerFichier(Token)}
    >
        <i className="fa fas fa-download" /> {Nom || `Fichier sans nom n°${Num + 1}`}
    </a>
);

const PopupTelecharger = (Id) => {
    obtenirDocument(Id).then((data) => {
        if (data && data.LsFichiers.length > 0) {
            const { LsFichiers } = data;
            if (LsFichiers.length === 1) {
                /* Télécharge automatiquement si un seul fichier */
                window.location.href = telechargerFichier(data.LsFichiers[0].Token);
            } else {
                /* Pop-up si plusieurs fichiers */
                const liens = data.LsFichiers.map((element, i) => <LigneTelechargement key={i} {...element} Num={i} />);

                swalReact.fire({
                    title: 'Téléchargement de fichiers',
                    html: <div>{liens}</div>,
                    confirmButtonText: 'Fermer',
                });
            }
        } else {
            swal({
                type: 'info',
                title: 'Aucun fichier',
            });
        }
    });
};

export default PopupTelecharger;



// WEBPACK FOOTER //
// ./src/components/PopupTelecharger.js